import 'babel-polyfill';
import Vue from 'vue';
import store from './store';
import axios from 'axios';

import App from './App.vue';
import config from './prototypes/config';
import i18n from './i18n';

// Axios setup
const baseAppUrl = document.body.querySelector('input[name="_baseUrl"]').value;
const csrf_token = document.body.querySelector('input[name="_token"]').value;

// Submit csrf token with every request
window.axios = axios.create({
  baseUrl: baseAppUrl,
  data: {
    _token: csrf_token
  }
});

window.axios.defaults.headers.common = {
  'X-CSRF-TOKEN': csrf_token,
  'X-Requested-With': 'XMLHttpRequest' // For Request::Ajax()
};

// eslint-disable-next-line no-undef
Vue.directive('track', require('./../directives/track'));

Vue.filter('pluralize', (word, amount) => {
  return amount > 1 ? `${word}s` : word;
});

Vue.prototype.$config = config;

// eslint-disable-next-line no-unused-vars
const vm = new Vue({
  store,
  i18n,
  render: h => h(App)
}).$mount('#plan-builder-app-container');
